import { Directive, ElementRef, Input, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[credit]',
  standalone: true,
})
export class CreditDirective {
  @Input('credit') creditNum: number = 0;

  constructor(public el: ElementRef<HTMLElement>) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.setStyle();
  }

  setStyle() {
    const creditNumberElement =
      this.el.nativeElement.querySelector('.credit-number');
    const creditNumberText = this.el.nativeElement.querySelector(
      '.credit-number-text'
    );
    const creditCurrency =
      this.el.nativeElement.querySelector('.credit-currency');

    // const creditCurrencyElement = this.el.nativeElement.querySelector(".credit-currency");

    if (this.creditNum < 0) {
      this.el.nativeElement.classList.add('text-danger');
      creditNumberElement?.classList.add('dir-ltr');
      creditNumberText?.classList.add('text-danger');
      creditCurrency?.classList.add('text-danger');
    } else {
      const isDanger = creditNumberText?.classList.contains('text-danger');
      if (isDanger) {
        creditNumberText?.classList.remove('text-danger');
        creditCurrency?.classList.remove('text-danger');
      }
    }
  }
}
